import { useContext, useEffect, useRef } from 'react'
import { State } from '../utils/context'
import { useSearch } from '../utils/search'
import Close from '../icons/close'
import styles from './form.module.css'

const DELAY = 250

const Form = props => {
  const [{search, active}, setState] = useContext(State)
  const {submit, live} = useSearch()
  const ref = useRef()
  const timer = useRef()

  const setInput = value => setState(state => ({
    ...state,
    search: {
      ...state.search,
      input: value
    }
  }))

  const onChange = e => {
    const value = e.target.value

    setInput(value)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => live(value), DELAY)
  }

  // Stan fokusu pola trzymamy w `active.input`, bo zależą od niego skróty klawiszowe.
  const onFocus = focused => setState(state => state.active.input == focused ? state : {
    ...state,
    active: {
      ...state.active,
      input: focused
    }
  })

  const onClear = () => {
    clearTimeout(timer.current)
    setInput('')
    live('')
    ref.current.focus()
  }

  const onSubmit = e => {
    e.preventDefault()
    clearTimeout(timer.current)
    ref.current.blur()
    submit(search.input)
  }

  useEffect(() => () => clearTimeout(timer.current), [])

  useEffect(() => {
    active.search && active.input ? ref.current.focus({preventScroll: true}) : ref.current.blur()
  }, [active.search, active.input])

  return (
    <form
      className={styles.form}
      hidden={!active.search}
      onSubmit={onSubmit}
    >
      <input
        className={styles.input}
        ref={ref}
        type="search"
        name={props.name}
        value={search.input}
        onChange={onChange}
        onFocus={() => onFocus(true)}
        onBlur={() => onFocus(false)}
        placeholder="np. J 3,16 lub miłość"
        autoComplete="off"
        enterKeyHint="search"
        aria-label={props.label}
      />
      {search.input && (
        <button
          className={styles.clear}
          type="button"
          onMouseDown={e => e.preventDefault()}
          onClick={onClear}
          aria-label="Clear Search"
        >
          <Close />
        </button>
      )}
    </form>
  )
}

export default Form
